import { Perfil } from "../perfil/perfil.model";
import {IdNome} from '../id-nome.model';
import { Setor } from "../setor/setor.model";

export class Usuario {
  id?: number;
  nome?: string;
  cpf?: string;
  telefone?: number;
  email?: string;
  cargo?: string;
  usuarioAd?: string;
  perfis?: number;
  prefixoGrupo?: string;
  grupo?: any;
  login?: string;
  ativo?: boolean;
  perfil?: Perfil;
  ldapHabilitado?: boolean;
  urlImg?: string;
  imgBase64?: string;
  extensaoImg?: string;
  uuid?: string;
  isOperador?: boolean;
  isCoordenador?: boolean;
  canais?: IdNome[];
  setorDTO?: Setor;

  constructor(id?: number, nome?: string, cpf?: string, telefone?: number, email?: string, cargo?: string, usuarioAd?: string, perfis?: number, prefixoGrupo?: string,
              grupo?: any, login?: string, ativo?: boolean, perfil?: Perfil, ldapHabilitado?: boolean, urlImg?: string, imgBase64?: string, extensaoImg?: string, uuid?: string, canais?: IdNome[], setorDTO?: Setor) {
    this.id = id;
    this.nome = nome;
    this.cpf = cpf;
    this.telefone = telefone;
    this.email = email;
    this.cargo = cargo;
    this.usuarioAd = usuarioAd;
    this.perfis = perfis;
    this.prefixoGrupo = prefixoGrupo;
    if(grupo)
      this.grupo = grupo;
    this.login = login;
    this.ativo = ativo;
    this.perfil = perfil;
    this.ldapHabilitado = ldapHabilitado;
    this.urlImg = urlImg;
    this.imgBase64 = imgBase64;
    this.extensaoImg = extensaoImg;
    this.uuid = uuid;
    this.canais = canais;
    this.setorDTO = setorDTO
  }
}
